import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronDown, faChevronUp, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_KMS from '../../../api/apiKMS';
import ActionType from '../../../redux/reducer/globalActionType';
import IconAddBlueBorder from '../../../assets/icons/IconAddBlueBorder';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import IconKMSLoadingData from '../../../assets/icons/IconKMSLoadingData';
import IconKMSNoData from '../../../assets/icons/IconKMSNoData';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_INSERT, SETTING_KMS_VIEW } from '../../../constants/menuPermissionConstant';

class KMSCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allCategoryKMS: [
                { categoryKMS: [], activeSelectedLevel: "", level: 1, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 2, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 3, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 4, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 5, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 6, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 7, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 8, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
                { categoryKMS: [], activeSelectedLevel: "", level: 9, pagination: { current: 1, pageSize: 10, total: 0, parentId: "" } },
            ],
            activeSelected: "",
            searchKey: "",
            activeSelectedPaginationLevel: "",
            showLoadingData: true,
            showLoadingDropdown: {
                id: 0,
                show: false
            },
        }
    }

    handleSetQueryParams = () => {
        const params = new URLSearchParams();
        params.set('page', this.state.allCategoryKMS[0].pagination.current);
        params.set('limit', this.state.allCategoryKMS[0].pagination.pageSize);
        params.set('searchKey', this.state.searchKey);

        const queryString = params.toString();
        const newLocation = { ...this.props.location, search: `?${queryString}` };
        this.props.history.push(newLocation);
    }

    updateQueryParams = () => {
        const params = new URLSearchParams(this.props.location.search);
        const page = params.get('page') || 1;
        const limit = params.get('limit') || 10;
        const searchKey = params.get('searchKey') || '';

        this.setState({
            allCategoryKMS: [
                {
                    ...this.state.allCategoryKMS[0],
                    pagination: {
                        current: page,
                        pageSize: limit,
                    },
                },
                ...this.state.allCategoryKMS,
            ],
            searchKey,
        }, () => {
            this.setState(prevState => {
                const updatedCategoryKMS = prevState.allCategoryKMS.slice(1);
                return { allCategoryKMS: updatedCategoryKMS };
            });
            if (searchKey !== '') {
                this.getListCategoryKMSInitiateSearch(searchKey, 1);
                this.getListCategoryKMSSearch(
                    this.state.allCategoryKMS[0].pagination.current,
                    this.state.allCategoryKMS[0].pagination.pageSize,
                    searchKey,
                    1
                );
                return;
            }
            this.getListCategoryKMSInitiateByLevel(1);
            this.getListCategoryKMSByLevel(
                this.state.allCategoryKMS[0].pagination.current,
                this.state.allCategoryKMS[0].pagination.pageSize,
                1
            );
        });
    }

    componentDidMount() {
        this.updateQueryParams();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.search !== prevProps.location.search) {
            this.updateQueryParams();
        }
    }

    getListCategoryKMSInitiateByLevel = (level) => {
        API_KMS.getListCategoryKMSInitiateByLevel(level, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, total: getContent(res).count_data } }) : obj)
                    )
                }));
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListCategoryKMSByLevel = (current, pageSize, level) => {
        this.setState({ showLoadingData: true });
        API_KMS.getListCategoryKMSByLevel(current, pageSize, level, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { categoryKMS: getContent(res) }) : obj)
                    )
                }),
                    () => {
                        this.setState({ showLoadingData: false });
                    }
                );
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.setState({
                showLoadingData: false,
                errorMessage: getErrorMessage(err),
                showErrorAlertResponse: true
            })
        }))
    }

    getListCategoryKMSInitiateNextLevel = (level, parentId) => {
        API_KMS.getListCategoryKMSInitiateNextLevel(level, parentId, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, total: getContent(res).count_data } }) : obj)
                    )
                }));
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListCategoryKMSByLevelNextLevel = async (current, pageSize, level, parentId) => {
        await this.setState({
            showLoadingDropdown: {
                id: parentId,
                show: true
            }
        });
        API_KMS.getListCategoryKMSNextLevel(current, pageSize, level, parentId, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === (level) ? Object.assign(obj, { categoryKMS: getContent(res) }) : obj)
                    )
                }),
                    () => {
                        this.setState({
                            showLoadingDropdown: {
                                id: 0,
                                show: false
                            }
                        });
                    }
                );
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.setState({
                showLoadingDropdown: {
                    id: 0,
                    show: false
                }
            });
        }))
    }

    getListCategoryKMSInitiateSearchCategoryLevelOne = (key, level) => {
        API_KMS.getListCategoryKMSInitiateSearchCategoryLevelOne(key, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, total: getContent(res).count_data } }) : obj)
                    )
                }));
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListCategoryKMSSearchCategoryLevelOne = (current, pageSize, key, level) => {
        this.setState({ showLoadingData: true });
        API_KMS.getListCategoryKMSSearchCategoryLevelOne(current, pageSize, key, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === (level) ? Object.assign(obj, { categoryKMS: getContent(res) }) : obj)
                    )
                }),
                    () => {
                        this.setState({ showLoadingData: false });
                    }
                );
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.setState({ showLoadingData: false });
        }))
    }

    getListCategoryKMSInitiateSearch = (key, level) => {
        API_KMS.getListCategoryKMSInitiateSearch(key, level, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, total: getContent(res).count_data } }) : obj)
                    )
                }));
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListCategoryKMSSearch = (current, pageSize, key, level) => {
        this.setState({ showLoadingData: true });
        API_KMS.getListCategoryKMSSearch(current, pageSize, key, level, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === (level) ? Object.assign(obj, { categoryKMS: getContent(res) }) : obj)
                    )
                }),
                    () => {
                        this.setState({ showLoadingData: false });
                    }
                );
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.setState({ showLoadingData: false });
        }))
    }

    getListCategoryKMSInitiateSearchWithParentId = (key, level, parentId) => {
        API_KMS.getListCategoryKMSInitiateSearchWithParentId(key, level, parentId, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === level ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, total: getContent(res).count_data } }) : obj)
                    )
                }));
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListCategoryKMSSearchWithParentId = async (current, pageSize, key, level, parentId) => {
        await this.setState({
            showLoadingDropdown: {
                id: parentId,
                show: true
            }
        });
        API_KMS.getListCategoryKMSSearchWithParentId(current, pageSize, key, level, parentId, this.props.token).then(
            res => {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === (level) ? Object.assign(obj, { categoryKMS: getContent(res) }) : obj)
                    )
                }),
                    () => {
                        this.setState({
                            showLoadingDropdown: {
                                id: 0,
                                show: false
                            }
                        });
                    }
                );
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.setState({
                showLoadingDropdown: {
                    id: 0,
                    show: false
                }
            });
        }))
    }

    handleDetailKMSCategory = value => {
        this.props.history.push(`/settings/kms/category/detail/${value.id}`);
    }

    handleSelectedPage = (currentPage, level) => {
        this.setState(prevState => ({
            activeSelected: "",
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level >= level ? Object.assign(obj, { categoryKMS: [], activeSelectedLevel: "" }) : obj)
            )
        }));
        this.setState(prevState => ({
            allCategoryKMS: prevState.allCategoryKMS.map((obj, index) => (
                obj.level === level
                    ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[level - 1].pagination, current: currentPage } })
                    : obj.level > level
                        ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[index].pagination, current: 1 } })
                        : obj
            ))
        }),
            () => {
                this.handleSetQueryParams();

                if (level !== 1 && this.state.searchKey === "") {
                    return this.getListCategoryKMSByLevelNextLevel(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, level, this.state.allCategoryKMS[level - 1].pagination.parentId);
                }
                if (level !== 1 && this.state.searchKey !== "") {
                    return this.getListCategoryKMSSearchWithParentId(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, this.state.searchKey, level, this.state.allCategoryKMS[level - 1].pagination.parentId);
                }
                if (level === 1 && this.state.searchKey !== "") {
                    return this.getListCategoryKMSSearch(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, this.state.searchKey, 1);
                }
                this.getListCategoryKMSByLevel(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, level);
            }
        );
    }

    handleSelectedPageSize = (currentPageSize, level) => {
        this.setState(prevState => ({
            activeSelected: "",
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level >= level ? Object.assign(obj, { categoryKMS: [], activeSelectedLevel: "" }) : obj)
            )
        }));
        this.setState(prevState => ({
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level === (level) ? Object.assign(obj, {
                    pagination: {
                        ...this.state.allCategoryKMS[level - 1].pagination,
                        pageSize: currentPageSize,
                        current: 1,
                    }
                }) : obj)
            )
        }),
            () => {
                this.handleSetQueryParams();

                if (level !== 1 && this.state.searchKey === "") {
                    return this.getListCategoryKMSByLevelNextLevel(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, level, this.state.allCategoryKMS[level - 1].pagination.parentId);
                }
                if (level !== 1 && this.state.searchKey !== "") {
                    return this.getListCategoryKMSSearchWithParentId(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, this.state.searchKey, level, this.state.allCategoryKMS[level - 1].pagination.parentId);
                }
                if (level === 1 && this.state.searchKey !== "") {
                    return this.getListCategoryKMSSearch(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, this.state.searchKey, 1);
                }
                this.getListCategoryKMSByLevel(this.state.allCategoryKMS[level - 1].pagination.current, this.state.allCategoryKMS[level - 1].pagination.pageSize, level);
            }
        );
    }

    handleCancelDropdown = data => {
        this.setState(prevState => ({
            activeSelected: "",
            activeSelectedPaginationLevel: data.level,
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level >= data.level ? Object.assign(obj, { activeSelectedLevel: "" }) : obj)
            )
        }));
    }

    handleDropdownLevel = data => {
        this.setState(prevState => ({
            activeSelected: "",
            activeSelectedPaginationLevel: data.level + 1,
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level >= (data.level + 1) ? Object.assign(obj, { activeSelectedLevel: "" }) : obj)
            )
        }));
        this.setState(prevState => ({
            activeSelected: data.id,
            allCategoryKMS: prevState.allCategoryKMS.map(
                obj => (obj.level === data.level ? Object.assign(obj, { activeSelectedLevel: data.id }) : obj)
            )
        }));

        if (data.level <= 9) {
            this.setState(prevState => ({
                allCategoryKMS: prevState.allCategoryKMS.map(
                    obj => (obj.level === (data.level + 1) ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[data.level].pagination, parentId: data.id } }) : obj)
                )
            }));
        }

        if (this.state.searchKey !== "") {
            this.getListCategoryKMSInitiateSearchWithParentId(this.state.searchKey, data.level + 1, data.id);
            this.getListCategoryKMSSearchWithParentId(this.state.allCategoryKMS[data.level].pagination.current, this.state.allCategoryKMS[data.level].pagination.pageSize, this.state.searchKey, data.level + 1, data.id);
            return
        }

        this.getListCategoryKMSInitiateNextLevel((data.level + 1), data.id);
        this.getListCategoryKMSByLevelNextLevel(this.state.allCategoryKMS[data.level].pagination.current, this.state.allCategoryKMS[data.level].pagination.pageSize, (data.level + 1), data.id);
    }

    handleSearch = e => {
        if (e.key === "Enter") {
            let defaultCurrent = 1;
            let defaultPageSize = 10;
            let defaultLevel = 1;
            this.setState(prevState => ({
                activeSelected: "",
                allCategoryKMS: prevState.allCategoryKMS.map(
                    obj => (obj.level >= defaultLevel ? Object.assign(obj, { categoryKMS: [], activeSelectedLevel: "" }) : obj)
                )
            }));
            if (this.state.searchKey === "") {
                this.setState(prevState => ({
                    allCategoryKMS: prevState.allCategoryKMS.map(
                        obj => (obj.level === defaultLevel ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[0].pagination, current: defaultCurrent, pageSize: defaultPageSize } }) : obj)
                    )
                }),
                    () => {
                        this.handleSetQueryParams();

                        this.getListCategoryKMSInitiateByLevel(defaultLevel);
                        this.getListCategoryKMSByLevel(defaultCurrent, defaultPageSize, defaultLevel);
                    }
                );
                return
            }
            this.setState(prevState => ({
                allCategoryKMS: prevState.allCategoryKMS.map(
                    obj => (obj.level === defaultLevel ? Object.assign(obj, { pagination: { ...this.state.allCategoryKMS[0].pagination, current: defaultCurrent, pageSize: defaultPageSize } }) : obj)
                )
            }),
                () => {
                    this.handleSetQueryParams();

                    this.getListCategoryKMSInitiateSearch(this.state.searchKey, defaultLevel);
                    this.getListCategoryKMSSearch(defaultCurrent, defaultPageSize, this.state.searchKey, defaultLevel);
                }
            );
        }
    }

    accordionLevelOne = (dataKMS, activeLevel, pagination, startLevel, maxLevel) => {
        return (
            <>
                {dataKMS.map((data, index) =>
                    <div id={`btnlevel${startLevel}`} key={`level-one-category-kms-${data.id}`} className="bg-white rounded shadow-box-button">
                        <div className={`p-5 space-y-3`}>
                            <div className="flex items-center justify-between">
                                <div className="w-9/12">
                                    <div className="font-medium text-xl">{`Level ${data.level}`}</div>
                                    <div className="text-gray-500 truncate" title={data.category}>{data.category}</div>
                                </div>
                                <div className="flex items-center space-x-8">
                                    <div id="btnviewdetail" className="font-medium text-olddarkblue cursor-pointer" onClick={() => this.handleDetailKMSCategory(data)}>Lihat Detail</div>
                                    {data.list_level.category_list && !data.last_level ?
                                        <>
                                            {this.state.showLoadingDropdown.show && this.state.showLoadingDropdown.id === data.id
                                                ? <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                                : <FontAwesomeIcon
                                                    id={activeLevel === data.id ? "btnexpand" : "btncollapse"}
                                                    icon={activeLevel === data.id ? faChevronUp : faChevronDown}
                                                    className="-mt-1 text-xl cursor-pointer focus:bg-black"
                                                    onClick={activeLevel === data.id ? () => this.handleCancelDropdown(data) : () => this.handleDropdownLevel(data)} />

                                            }
                                        </>
                                        :
                                        <FontAwesomeIcon icon={faChevronDown} className="-mt-1 opacity-0" />
                                    }
                                </div>
                            </div>
                        </div>
                        {activeLevel === data.id &&
                            <>
                                {this.accordionNextLevel(this.state.allCategoryKMS[startLevel].categoryKMS, this.state.allCategoryKMS[startLevel].activeSelectedLevel, this.state.allCategoryKMS[startLevel].pagination, startLevel, maxLevel)}
                            </>
                        }
                    </div>
                )}
                {
                    pagination.total > 10 ?
                        <div className="font-bold select-none">
                            <CustomPagination
                                titlePageSize={`Data Per Halaman Level ${startLevel}`}
                                paginationLevel={1}
                                pagination={pagination}
                                onPage={this.handleSelectedPage}
                                onPageSize={this.handleSelectedPageSize}
                            />
                        </div>
                        :
                        <br />
                }
            </>
        )
    }

    accordionNextLevel = (dataKMSLevel, activeSelectedLevel, pagination, startLevel, maxLevel) => {
        let increaseStartLevel = startLevel
        if (startLevel <= maxLevel) {
            increaseStartLevel = increaseStartLevel + 1
        }
        return (
            <>
                <div id={`btnlevel${increaseStartLevel}`} className="rounded-b-lg">
                    {dataKMSLevel.map((dataNext, index) =>
                        <div key={`level-${dataNext.level}-category-kms-${dataNext.id}`} className={`${dataNext.level % 2 === 0 ? "bg-blue-100" : "bg-blue-200"}`}>
                            <div className={`p-5 space-y-3`}>
                                <div className="flex items-center justify-between ml-10">
                                    <div className="w-8/12">
                                        <div className="font-medium text-xl">{`Level ${dataNext.level}`}</div>
                                        <div className="text-gray-500 truncate" title={dataNext.category}>{dataNext.category}</div>
                                    </div>
                                    <div className="flex items-center space-x-8">
                                        <div className="font-medium text-olddarkblue cursor-pointer" onClick={() => this.handleDetailKMSCategory(dataNext)}>Lihat Detail</div>
                                        {dataNext.list_level.category_list && !dataNext.last_level ?
                                            <>
                                                {
                                                    this.state.showLoadingDropdown.show && this.state.showLoadingDropdown.id === dataNext.id
                                                        ? <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                                        : <FontAwesomeIcon
                                                            id={activeSelectedLevel === dataNext.id ? "btnexpand" : "btncollapse"}
                                                            icon={activeSelectedLevel === dataNext.id ? faChevronUp : faChevronDown}
                                                            className="-mt-1 text-xl cursor-pointer focus:bg-black"
                                                            onClick={activeSelectedLevel === dataNext.id ? () => this.handleCancelDropdown(dataNext) : () => this.handleDropdownLevel(dataNext)} />
                                                }
                                            </>
                                            :
                                            <FontAwesomeIcon icon={faChevronDown} className="-mt-1 opacity-0" />
                                        }
                                    </div>
                                </div>
                            </div>
                            {(activeSelectedLevel === dataNext.id && startLevel <= maxLevel) &&
                                <>
                                    {this.accordionNextLevel(this.state.allCategoryKMS[increaseStartLevel].categoryKMS, this.state.allCategoryKMS[increaseStartLevel].activeSelectedLevel, this.state.allCategoryKMS[increaseStartLevel].pagination, increaseStartLevel, maxLevel)}
                                </>
                            }
                        </div>
                    )}
                    {
                        (pagination.total > 10 && this.state.activeSelectedPaginationLevel === increaseStartLevel) &&
                        <div className="font-bold select-none rounded-b-lg bg-blue-300">
                            <CustomPagination
                                titlePageSize={`Data Per Halaman Level ${increaseStartLevel}`}
                                paginationLevel={increaseStartLevel}
                                pagination={pagination}
                                onPage={this.handleSelectedPage}
                                onPageSize={this.handleSelectedPageSize}
                            />
                        </div>
                    }
                </div>
            </>
        )
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_KMS_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="KMS"
                        title="Knowledge Management Sistem"
                    />

                    <div className="space-y-3">
                        {/* FILTER */}
                        <div className="flex justify-between items-center">
                            <div className="bg-white w-1/4 h-12 rounded p-3 mt-1 focus-within:border-gray-400 border">
                                <div className="flex items-center rounded-full bg-white px-2">
                                    <input id="tslsearch" type="text" placeholder={"Cari Judul"} className="outline-none w-full" value={this.state.searchKey} onKeyDown={this.handleSearch} onChange={(e) => { this.setState({ searchKey: e.target.value }) }} />
                                    <div>
                                        <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                                    </div>
                                </div>
                            </div>

                            <CheckPermissionComponent permissionConstant={[SETTING_KMS_INSERT]} userPermission={this.props.userDetail.permissions}>
                                {/* Add KMS Category */}
                                <NavLink
                                    id="btnaddcategory"
                                    to={ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY_ADD}
                                    className="flex items-center cursor-pointer bg-olddarkblue text-white py-2 px-6 rounded-lg"
                                >
                                    <IconAddBlueBorder />
                                    <span className="ml-2">Tambah Kategori</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </div>

                        {/* CONTENT */}
                        {this.state.showLoadingData ?
                            <div className="flex flex-col justify-center items-center" style={{ height: "70vh" }}>
                                <IconKMSLoadingData />
                                <p className="text-2xl text-black font-bold mt-5">Data sedang di proses.</p>
                                <p className="text-xl text-gray-500 mt-5">Mohon menunggu, Data sedang di proses.</p>
                            </div>
                            :
                            <div className="space-y-5">
                                {/* Tampilan jika data kosong */}
                                {this.state.allCategoryKMS[0].categoryKMS.length > 0 ?
                                    <>
                                        {this.accordionLevelOne(this.state.allCategoryKMS[0].categoryKMS, this.state.allCategoryKMS[0].activeSelectedLevel, this.state.allCategoryKMS[0].pagination, 1, 9)}
                                    </>
                                    :
                                    <>
                                        <div className="flex flex-col justify-center items-center" style={{ height: "70vh" }}>
                                            <IconKMSNoData />
                                            <p className="text-2xl text-black font-bold mt-5">Tidak Ada Data KMS</p>
                                            <p className="text-xl text-gray-500 mt-5">Silahkan buat data baru di tambah kategori</p>
                                        </div>
                                    </>
                                }
                            </div>
                        }
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSCategory);